const MetricChartTooltip = ({ value, label, comparedData = null }) => {
  return !comparedData ? (
    <div className="metric-tooltip">
      <div className="metric-tooltip__top">{value}</div>
      {label && <div className="metric-tooltip__bottom">{label}</div>}
    </div>
  ) : (
    <div className="metric-tooltip metric-tooltip--compared">
      {comparedData.map((item, index) => {
        return (
          <div className="metric-tooltip-item" key={index} style={{ color: item.color }}>
            <span className="metric-tooltip-item__title">{item.name}</span>
            <span className="metric-tooltip-item__value">{item.value}</span>
          </div>
        );
      })}
    </div>
  );
};

export default MetricChartTooltip;
